import { useCallback, useState } from 'react';
import { authRepository, useAuthStore } from '@web/data/repositories';

interface UseAuthLogin {
  signIn: (opts?: { returnTo?: string }) => Promise<void>;
  signOut: () => Promise<void>;
  pending: boolean;
  error: string | null;
  isAuthenticated: boolean;
}

export function useAuthLogin(): UseAuthLogin {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = !!user;

  const signIn = useCallback(
    async (opts?: { returnTo?: string }): Promise<void> => {
      if (pending) return;
      setError(null);
      setPending(true);
      try {
        await authRepository.beginLogin(opts);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Falha ao iniciar login.');
        setPending(false);
      }
    },
    [pending],
  );

  const signOut = useCallback(async (): Promise<void> => {
    await authRepository.signOut();
  }, []);

  return { signIn, signOut, pending, error, isAuthenticated };
}
